import "./Mapa.css";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaDirections,
  FaMapMarkedAlt,
  FaRoad,
  FaShoppingBag,
  FaChartLine,
  FaShieldAlt,
  FaBuilding,
  FaExternalLinkAlt,
} from "react-icons/fa";

function Mapa() {
  const googleMapsUrl =
    "https://www.google.com/maps/search/?api=1&query=Camino+del+Sol+Madre+Vieja+Sur+San+Cristobal";

  return (
    <section className="mapa" id="ubicacion">
      <div className="mapa-container">

        {/* COLUMNA IZQUIERDA */}

        <div className="mapa-info">
          <span className="mapa-subtitle">
            Ubicación del proyecto
          </span>

          <span className="mapa-linea"></span>

          <h2>
            Un entorno estratégico para vivir e invertir
          </h2>

          <p className="mapa-descripcion">
            Residencial <strong>YANNA I</strong> está ubicado en
            <strong> Madre Vieja Sur, San Cristóbal</strong>, una zona
            con excelente conectividad, crecimiento urbano y gran
            potencial de valorización.
          </p>

          <div className="mapa-datos">

            <div className="dato-card">
              <div className="dato-icono">
                <FaMapMarkerAlt />
              </div>

              <div>
                <strong>Dirección</strong>
                <span>
                  Camino del Sol, Madre Vieja Sur, San Cristóbal
                </span>
              </div>
            </div>

            <div className="dato-card">
              <div className="dato-icono">
                <FaPhoneAlt />
              </div>

              <div>
                <strong>Teléfono</strong>
                <span>+1 (829) 962-3399</span>
              </div>
            </div>

            <div className="dato-card">
              <div className="dato-icono">
                <FaEnvelope />
              </div>

              <div>
                <strong>Correo</strong>
                <span>yannelizaaybar@gmail.com</span>
              </div>
            </div>

            <div className="dato-card">
              <div className="dato-icono">
                <FaClock />
              </div>

              <div>
                <strong>Horario</strong>
                <span>Lunes a Domingo · 8:00 AM - 6:00 PM</span>
              </div>
            </div>

          </div>

          <div className="mapa-destacado">
            <div className="mapa-destacado-icono">
              <FaMapMarkedAlt />
            </div>

            <div>
              <h3>Fácil acceso, mejor ubicación</h3>

              <p>
                Conectado a las principales vías de San Cristóbal y a
                pocos minutos de todo lo que necesitas.
              </p>
            </div>
          </div>
        </div>

        {/* COLUMNA DERECHA */}

        <div className="mapa-contenido">

          <div className="mapa-card">

            <div className="mapa-encabezado">

              <div className="mapa-encabezado-info">
                <div className="mapa-encabezado-icono">
                  <FaMapMarkerAlt />
                </div>

                <div>
                  <span>Localización</span>

                  <h3>Residencial YANNA I</h3>

                  <p>
                    Camino del Sol, Madre Vieja Sur, San Cristóbal
                  </p>
                </div>
              </div>

              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noreferrer"
                className="btn-direcciones"
              >
                <FaDirections />
                Cómo llegar
              </a>

            </div>

            <div className="mapa-google">

              <iframe
                title="Ubicación Residencial YANNA I"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=Madre%20Vieja%20Sur%20San%20Cristobal%20Republica%20Dominicana&z=13&output=embed"
              />

              <div className="mapa-flotante">
                <div className="mapa-flotante-icono">
                  <FaBuilding />
                </div>

                <div>
                  <h4>Residencial YANNA I</h4>

                  <p>
                    Camino del Sol, Madre Vieja Sur,
                    San Cristóbal
                  </p>

                  <a
                    href={googleMapsUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver en Google Maps
                    <FaExternalLinkAlt />
                  </a>
                </div>
              </div>

            </div>

          </div>

          {/* BENEFICIOS */}

          <div className="mapa-beneficios">

            <div className="mapa-beneficio">
              <div className="mapa-beneficio-icono">
                <FaRoad />
              </div>

              <div>
                <h4>Accesibilidad</h4>
                <p>
                  Fácil acceso desde las principales vías de
                  San Cristóbal.
                </p>
              </div>
            </div>

            <div className="mapa-beneficio">
              <div className="mapa-beneficio-icono">
                <FaShoppingBag />
              </div>

              <div>
                <h4>Cerca de todo</h4>
                <p>
                  A pocos minutos de centros comerciales,
                  supermercados y colegios.
                </p>
              </div>
            </div>

            <div className="mapa-beneficio">
              <div className="mapa-beneficio-icono">
                <FaChartLine />
              </div>

              <div>
                <h4>Zona en crecimiento</h4>
                <p>
                  Sector con desarrollo urbano y gran
                  proyección de valorización.
                </p>
              </div>
            </div>

            <div className="mapa-beneficio">
              <div className="mapa-beneficio-icono">
                <FaShieldAlt />
              </div>

              <div>
                <h4>Inversión segura</h4>
                <p>
                  Un proyecto respaldado por calidad,
                  confianza y excelente ubicación.
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Mapa;